<!-- Lateral na medida única do projeto (`.layout-com-lateral`). -->
<div class="layout-com-lateral">
    <div class="w-full min-w-0">
        <app-dados-gerais [orgao]="orgao" [isLoading]="isLoading" [(uf)]="uf"></app-dados-gerais>
    </div>

    <div class="min-w-0">
        <app-card-content [border]="false" [headerColor]="false" title="Informações Adicionais" icon="pi pi-info-circle">
            <div card-header class="aba-switcher">
                <button type="button" class="aba-btn" [class.aba-ativa]="abaAtiva === '0'" (click)="abaAtiva = '0'">Contatos</button>
                <button type="button" class="aba-btn" [class.aba-ativa]="abaAtiva === '1'" (click)="abaAtiva = '1'">Composição</button>
                <button type="button" class="aba-btn" [class.aba-ativa]="abaAtiva === '2'" (click)="abaAtiva = '2'">Delegacias</button>
            </div>

            <div class="pt-4 sm:pt-6">
                @if (abaAtiva === '0') {
                    <app-contato
                        [appCan]="PERMISSOES.orgaos.contato.escopo"
                        [appCanUf]="uf"
                        [uf]="uf"
                        [pessoa]="contextoSolicitanteOrgao || undefined"
                        [iniciarComoCard]="true"
                        [roleEditarContato]="'orgaos.contato.editar'"
                        [roleExcluirContato]="'orgaos.contato.excluir'"
                        (dadosAtualizados)="recarregarDadosGeraisOrgao()"
                    ></app-contato>
                }
                @if (abaAtiva === '1') {
                    <app-composicao [appCan]="PERMISSOES.orgaos.composicao.escopo" [appCanUf]="uf" [uf]="uf" [pessoa]="contextoSolicitanteOrgao || undefined" (dadosAtualizados)="recarregarDadosGeraisOrgao()"></app-composicao>
                }
                @if (abaAtiva === '2') {
                    <app-delegacias [appCan]="PERMISSOES.orgaos.delegacias.escopo" [appCanUf]="uf" [uf]="uf" (dadosAtualizados)="recarregarDadosGeraisOrgao()"></app-delegacias>
                }
            </div>
        </app-card-content>
    </div>
</div>
